<template>
	<div class="Header__detail Header__init">
		<div class="left-btn-group">
			<button @click="closeAll" v-if="!removeClose">
				<img src="@/assets/svg/header-close.svg" alt="close" />
			</button>
			<button @click="goBack" v-if="!disabled">
				<img src="@/assets/svg/arrow-back.svg" alt="back" />
			</button>
		</div>
		<h5>{{ tt(title) }}</h5>
		<div class="right-btn-group" v-if="!removeClose">
			<button
				class="Btn__init"
				:class="{ active: isActive }"
				@click="initFilter"
			>
				{{ tt(initText) }}
			</button>
		</div>
	</div>
</template>

<script>
import MixinData from '@/mixins/index.js'
import { mapMutations } from 'vuex'

export default {
	name: 'InitHeader',
	mixins: [MixinData],
	props: {
		title: {
			type: String,
			default: '',
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		goBack: {
			type: Function,
			default: () => {},
		},
		closeAll: {
			type: Function,
			default: () => {},
		},
		removeClose: {
			type: Boolean,
		},
		isActive: {
			type: Boolean,
			defaul: false,
		},
		initText: {
			type: String,
			default: '초기화',
		},
	},
	methods: {
		...mapMutations('inventory', ['setInitFilter']),
		hidePopup() {
			this.$emit('hidePopup')
		},
		initFilter() {
			if (!this.isActive) return
			this.setInitFilter()
			this.$emit('initFilter')
		},
	},
}
</script>
